const NOTIFICATION_BADGES_KEY = ['notificationBadges']

export const notificationBadgesKeys = {
  all: NOTIFICATION_BADGES_KEY,
  list: patientIds => [
    ...notificationBadgesKeys.all,
    'list',
    [...(patientIds || [])].slice().sort()
  ]
}
